import { type GraphQLResult, generateClient } from 'aws-amplify/api'

const client = generateClient()

export type { GraphQLResult }

export function graphql<T = unknown>(
	query: string,
	variables?: Record<string, unknown>
) {
	return client.graphql({
		query,
		variables,
	}) as T
}

export function graphqlOperation(
	query: string,
	variables?: Record<string, unknown>
) {
	return {
		query,
		variables,
	}
}
